const en = {
	// Sidebar
	sidebarIntro: 'Hi, my name is Jordy and I\'m a full-stack web developer. Have a look at my work!',
	hireMe: 'Hire Me',
	darkMode: 'Dark Mode',
	switchLanguage: 'Switch Language',

	// Menu
	aboutMe: 'About Me',
	portfolio: 'Portfolio',
	resume: 'Resume',
	contact: 'Contact',

	// About me
	name: 'Jordy van der Poel',
	title: 'Full-stack web developer',
	view: 'View',
	aboutMeLong: 'I\'m a software engineer specialised in frontend and backend development for complex scalable web applications. Want to know how I may help your project?',
	haveALook: 'Have a look at my',
	whatIDo: 'What I Do',
	whatIDoLong: 'I have several years of experience in developing customized solutions for several clients. Below is a quick overview of my main technical skill sets and technologies I use. Want to find out more about my experience?',
	checkOutMy: 'Check out my',
	onlineResume: 'online resume',
	and: 'and',
	projectPortfolio: 'project portfolio',
	featuredProjects: 'Featured Projects',
	viewPortfolio: 'View Portfolio',

	// Resume
	downloadPDF: 'Download PDF version',
	resumeSummary1: 'Results-driven computer science student with a passion for helping others.',
	resumeSummary2: '5+ years of experience in full-stack web development and excited to learn new strategies and technologies.',
	workExperiences: 'Work Experiences',
	projects: 'Projects',
	skills: 'Skills',
	technical: 'Technical',
	professional: 'Professional',
	education: 'Education',
	languages: 'Languages',
	interests: 'Interests',
	technologies: 'Technologies',

	// Portfolio
	earlierWorks: 'Have a look at my earlier works!',
	takingOnWork: 'I\'m taking on freelance work at the moment.',
	wantHelp: 'Want some help building your website of web application?',
	viewProject: 'View Project',
	likeProjects: 'Do you like a project and want more details? Let me know!',

	// Contact
	interested: 'Interested in hiring me for your project or just want to say hi?',
	sendEmail: 'You can send me an email to',
	getConnected: 'Want to get connected? Follow me on the social channels below.',

};

export default en;